<template>
  <div class="voucher-notice">
    <div class="common-benefit partner-benefit-box">
      <strong class="title">{{ benefitTitle }}</strong>
      <ul class="common-benefit-list">
        <li
          v-for="(item, index) in benefitList"
          :key="`common_benefits__${index}`"
        >
          <span v-html="item"></span>
        </li>
      </ul>
    </div>

    <VoucherBottomGuide :device="device" />
  </div>
</template>
<script setup>
  import { computed, defineProps } from 'vue'
  import VoucherBottomGuide from '@/components/lnb/voucher/VoucherBottomGuide.vue'
  import { VOUCHER_COMMON_BENEFITS } from '@/components/lnb/voucher/voucher-text/const.js'

  // note: 현재는 사용하지 않음, 그러나 w-t-의경우 사용하기 때문에 프로퍼티 유지
  defineProps({
    device: {
      type: String,
      default: '',
    },
    voucherType: {
      type: String,
      default: '',
    },
  })

  const benefitTitle = computed(() => '이용권 공통 혜택')
  const benefitList = computed(() => VOUCHER_COMMON_BENEFITS)
</script>
<style lang="scss" scoped>
  .partner-benefit-box {
    .title {
      font-size: 14px;
      line-height: 20px;
      color: #fff;
      font-weight: 400;
    }
    .box {
      > dl {
        width: 100%;
        dt {
          font-size: 12px;
          line-height: 18px;
          font-weight: bold;
          color: #a5a5a5;
        }
        dd {
          position: relative;
          margin-top: 8px;
          padding-left: 24px;
          font-size: 12px;
          line-height: 16px;
          color: #a5a5a5;
          word-break: break-all;
          vertical-align: middle;
          &:first-of-type {
            margin-top: 12px;
          }
          &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 16px;
            height: 16px;
            background: url(~@/assets/images/ticket/element-icons-16-x-16-default-ic-check-list-small-copy@3x.png)
              no-repeat center / cover;
            vertical-align: middle;
          }
        }
      }
    }
  }
</style>
